import { DatalayersApiLoaderProvider } from "@omnia/shared/layers/loader"
import { createCalcSeedMapForm } from "./calcSeedMap/calcSeedMap"
import { loadSeedsLayers } from "./map/loader"
import { SeedsDatalayer } from "./map/seedsDatalayer"
import { SeedLayerViewer } from "./map/viewer"
import { MenuCtrl } from "./menu/menu"
import { createPlanCroppingList } from "./plan/cropping/cropping"
import { createBulkAdjustmentEditor } from "./plan/edit/bulkAdjustQty"
import { EditPlanCtrl } from "./plan/edit/editPlan"
import { SeedsCtrl } from "./seeds"
import { SeedsService } from "./services/service"
import { DatalayerFactoryProvider } from "@omnia/shared/layers/datalayerFactory"
import { LayerTypeId } from "@omnia/shared/generated/enums"
import { DatalayerViewManagerProvider } from "@omnia/shared/layers/viewManager"

export function setup(module: ng.IModule) {

    module

        .service("OmniaSeedsService", SeedsService)

        .directive("omniaSeeds", SeedsCtrl.create)

        .directive("omniaSeedsMenu", MenuCtrl.create)

        .directive("omniaSeedsPlanEdit", EditPlanCtrl.create)
        .directive("omniaSeedsPlanBulkAdjustQty", createBulkAdjustmentEditor)
        .directive("omniaSeedsPlanCropping", createPlanCroppingList)
        .directive("omniaSeedsMapCalcForm", createCalcSeedMapForm);

    module.config(["OmniaDatalayersApiLoaderProvider", (provider: DatalayersApiLoaderProvider) => {

        provider.addLoader(loadSeedsLayers);

    }]);

    module.config(["OmniaDatalayersFactoryProvider", (provider: DatalayerFactoryProvider) => {

        provider.register(LayerTypeId.SeedRate, (layer, ctxt) => SeedsDatalayer.create(layer, ctxt));

    }]);

    module.config(["OmniaDatalayersViewManagerProvider", (provider: DatalayerViewManagerProvider) => {

        provider.register([

            {
                typeId: LayerTypeId.SeedRate,
                name: "Seed rates",
                createViewer: l => SeedLayerViewer.createViewer(l)
            }

        ]);

    }]);

}
